import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { GO_BACK } from 'v3/routes/enum';
import { FieldStore } from 'v3/shared/components/FieldStore';
import { CommonTemplate } from 'v3/shared/templates/CommonTemplate';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
import { Container, Content, Header } from './styles';
export const CreateStores = () => {
  const navigate = useNavigate();
  return (
    <CommonTemplate>
      <Container>
        <Content>
          <Header>
            <ArrowBackIcon className="pointer" fontSize="large" onClick={() => navigate(GO_BACK)} />
            <HeadlineMedium>Adicionar nova loja</HeadlineMedium>
          </Header>
          <FieldStore />
        </Content>
      </Container>
    </CommonTemplate>
  );
};
